export default __webpack_public_path__ + "static/media/sample-R2-svgHeroYellowv2.62fe0273.svg";